import axios from 'axios'

export const baseURL = '/epul_api'

export const $public = axios.create({
  baseURL,
})

$public.interceptors.request.use(config => {
  config.headers['Payment-Origin'] = 'frames'
  return config
})
